import { Form, FormInstance, Input } from "antd";
import CloseIcon from "../../../../../assets/icons/CloseIcon";
import CheckboxesInputIcon from "../_icons/CheckboxesInputIcon";
import { QuestionTypeProps } from "../_types/type";

export default function CheckboxGridField({
  index,
  name,
  form,
}: QuestionTypeProps & { form: FormInstance<any>; name: string }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-20 mt-4">
      <div className="space-y-4">
        <span className="text-display-body font-medium">Row</span>
        <Form.List name={[index, "grid_rows"]} initialValue={["Option 1"]}>
          {(choices, { add, remove }) => (
            <>
              {choices.map((choiceField, idx) => (
                <div
                  key={choiceField.key}
                  className="flex items-center gap-2 mt-4"
                >
                  <CheckboxesInputIcon />
                  <Form.Item
                    name={[choiceField.name]}
                    className="flex-1 mb-0"
                    rules={[
                      {
                        required: true,
                        message: "Option is required",
                      },
                      {
                        validator: (_, value) => {
                          const options =
                            form.getFieldValue([name, index, "grid_rows"]) ||
                            [];

                          const currentIndex = Array.isArray(choiceField.name)
                            ? choiceField.name[choiceField.name.length - 1]
                            : choiceField.name;

                          const duplicate = options.filter(
                            (opt: string, i: number) =>
                              opt === value && i !== currentIndex,
                          );

                          if (duplicate.length > 0) {
                            return Promise.reject(
                              "Duplicate option not allowed",
                            );
                          }

                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Input
                      placeholder={`Option ${idx + 1}`}
                      className="!border-x-0 !border-t-0 !rounded-none !border-b-light !shadow-none"
                    />
                  </Form.Item>
                  {choices?.length > 1 && (
                    <span
                      onClick={() => remove(choiceField.name)}
                      className="text-status-dark-text cursor-pointer"
                    >
                      <CloseIcon />
                    </span>
                  )}
                </div>
              ))}
              <div className="flex items-center gap-2 mt-4">
                <CheckboxesInputIcon />
                <div className="text-sm font-medium text-display-dark pl-2">
                  Add option or{" "}
                  <button
                    className="text-primary"
                    onClick={() => add()}
                    type="button"
                  >
                    add “More”
                  </button>
                </div>
              </div>
            </>
          )}
        </Form.List>
      </div>
      <div className="space-y-4">
        <span className="text-display-body font-medium">Columns</span>
        <Form.List name={[index, "grid_columns"]} initialValue={["Option 1"]}>
          {(choices, { add, remove }) => (
            <>
              {choices.map((choiceField, idx) => (
                <div
                  key={choiceField.key}
                  className="flex items-center gap-2 mt-4"
                >
                  <CheckboxesInputIcon />
                  <Form.Item
                    name={[choiceField.name]}
                    className="flex-1 mb-0"
                    rules={[
                      {
                        required: true,
                        message: "Option is required",
                      },
                      {
                        validator: (_, value) => {
                          const options =
                            form.getFieldValue([name, index, "grid_columns"]) ||
                            [];

                          const currentIndex = Array.isArray(choiceField.name)
                            ? choiceField.name[choiceField.name.length - 1]
                            : choiceField.name;

                          const duplicate = options.filter(
                            (opt: string, i: number) =>
                              opt === value && i !== currentIndex,
                          );

                          if (duplicate.length > 0) {
                            return Promise.reject(
                              "Duplicate option not allowed",
                            );
                          }

                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Input
                      placeholder={`Option ${idx + 1}`}
                      className="!border-x-0 !border-t-0 !rounded-none !border-b-light !shadow-none"
                    />
                  </Form.Item>
                  {choices?.length > 1 && (
                    <span
                      onClick={() => remove(choiceField.name)}
                      className="text-status-dark-text cursor-pointer"
                    >
                      <CloseIcon />
                    </span>
                  )}
                </div>
              ))}
              <div className="flex items-center gap-2 mt-4">
                <CheckboxesInputIcon />
                <div className="text-sm font-medium text-display-dark pl-2">
                  Add option or{" "}
                  <button
                    className="text-primary"
                    onClick={() => add()}
                    type="button"
                  >
                    add “More”
                  </button>
                </div>
              </div>
            </>
          )}
        </Form.List>
      </div>
    </div>
  );
}
